import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field } from "formik";
import React, {useState } from "react";
import { store } from "../../App";
import NavigationServicesHeader from "../../Header/NavigationServicesHeader";
import HousingService from "../../Services/HousingService";
import { Form, FormGroup, Col } from "react-bootstrap";
import moment from "moment-timezone";
import jsPDF from "jspdf";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { AiOutlineSearch } from "react-icons/ai";
import { FaFileExcel, FaPrint } from "react-icons/fa";
import { GetDetails, ModuleHeader } from "../utils/commonFunctions";

const ApHomesProgressReport = () => {
    const todayDate = new Date();
    const [distList, setDistList] = useState([]);
    const [schemesList, setSchemesList] = useState([]);
    const [phaseList, setPhaseList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [table, setTable] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [schemesList1, setSchemesList1] = useState([]);
    const [phaseList1, setPhaseList1] = useState([]);
    const [DistList1, setDistList1] = useState([]);
    const [saveOptionScehme, setSaveOptionScehme] = useState([])
    const [saveOptionPhase, setSaveOptionPhase] = useState([])
    const [saveOptionDist, setSaveOptionDist] = useState([])
    const [saveDate, setSaveDate] = useState("")
    React.useEffect(() => {
        let params = {
            dist_code: 0,
            div_code: 0,
            cont_code: 0,
            mandal_code: 0,
            village_code: 0,
        };
        HousingService.AphomesDistrictMaster(params).then((res) => {
            if (res.data) {
                setDistList1(res.data)
                let options = res.data.map((item, i) => {
                    return (
                        <option key={i} value={item.dist_code}>
                            {item.dist_name}
                        </option>
                    );
                });
                setDistList(options);
            }
        });
        HousingService.getAphomesPhasesDropdown().then((res) => {
            if (res.data) {
                setPhaseList1(res.data)
                let options = res.data.map((item, i) => {
                    return (
                        <option key={i} value={item.phase}>
                            {item.phase_name}
                        </option>
                    );
                });
                setPhaseList(options);
            }
        });
        HousingService.getAphomesSchemesDropdown().then((res) => {
            if (res.data) {
                setSchemesList1(res.data)
                let options = res.data.map((item, i) => {
                    return (
                        <option key={i} value={item.scheme_id}>
                            {item.scheme_name}
                        </option>
                    );
                });
                setSchemesList(options);
            }
        });

    }, [])

    const formik = useFormik({
        initialValues: {
            district: "0",
            phase: "0",
            scheme: "0",
            date: "",

        },
        validate: (values) => {
            const errors = {};
            if (!values.date) {
                errors.date = "Date is required";
            }
            return errors;
        },
        onSubmit: (values) => {
            store.dispatch({ type: "SHOW_SPINNER" });
            setSaveDate(moment(values.date).format("DD-MM-YYYY"))
            if (values.scheme === "0") {
                setSaveOptionScehme("All")
            }
            else {
                let sch = schemesList1.find((item) => item.scheme_id == values.scheme)
                console.log("scheme_name", sch)
                setSaveOptionScehme(sch?.scheme_name)
            }
            if (values.phase === "0") {
                setSaveOptionPhase("All")
                console.log(phaseList1)
            }
            else {
                console.log(phaseList1)
                let phs = phaseList1.find((item) => item.phase == values.phase)
                console.log("phase_name", phs)
                setSaveOptionPhase(phs?.phase_name)
            }
            if (values.district === "0") {
                setSaveOptionDist("All")
            }
            else {
                let dist = DistList1.find((item) => item.dist_code == values.district)
                setSaveOptionDist(dist?.dist_name)
            }
            let params = { dist_code: values.district, phase: values.phase, scheme: values.scheme, fromdate: values.date }
            HousingService.getAphomesSchemesPhasesReport(params).then((res) => {
                setTableData(res.data)
            }).catch((error) => {
                // ShowAlert("Some Error occured",error)
            }).finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
                setTable(true)
            })
        }
    })
    const handleSearch = (event) => {
        setSearchText(event.target.value);
    };
    const filteredData = searchText.length > 0 ? tableData?.filter((item) => {
        return (item && Object.keys(item).some((key) => {
            const value = item[key];
            return (value !== null && value?.toString().toLowerCase().includes(searchText.toLowerCase()));
        }));
    }) : tableData
    function ApHomesPDF() {
        const pageWidth = 600;
        const pageHeight = 297;
        const doc = new jsPDF({
            orientation: "landscape",
            unit: "mm",
            format: [pageWidth, pageHeight],
        });

        const imgPath = "/img/APSHCL_logo.png";
        const distuser = localStorage.getItem("username");
        const headingText3 = ``;
        const headingText2 =
            "Andhra Pradesh State Housing Corporation Limited (APSHCL) Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007";
        const headingText4 =
            `AP Homes Progress Report as on Date :${saveDate} `;
        const fontSize = 6;
        const textWidth2 =
            (doc.getStringUnitWidth(headingText2) * fontSize) /
            doc.internal.scaleFactor;
        const textWidth3 =
            (doc.getStringUnitWidth(headingText3) * fontSize) /
            doc.internal.scaleFactor;
        const textWidth4 =
            (doc.getStringUnitWidth(headingText4) * fontSize) /
            doc.internal.scaleFactor;
        const tableYStart = 35; 
        doc.setFontSize(fontSize);
        const xCoordinate2 = (pageWidth * 1.5 - textWidth2) / 2;
        doc.text(headingText2, xCoordinate2, 10); 
        const xCoordinate3 = (pageWidth * 1.5 - textWidth3) / 2;
        const xCoordinate4 = (pageWidth * 1.5 - textWidth4) / 2;
        doc.text(headingText4, xCoordinate4, 20); 
        doc.text(headingText3, xCoordinate3, 30); 
        doc.addImage(imgPath, "PNG", 7, 7, 25, 25); 
        doc.autoTable({
            html: "#my-APHomesPDf",
            theme: "grid",
            tableWidth: "auto",
            columnStyles: {
                3: { cellWidth: "wrap" },
            },
            startY: tableYStart,
            margin: { top: 5, right: 15, bottom: 5, left: 15 },
            styles: {
                fontSize: 8,
            },
            columnWidth: { 0: 20, 1: 30, 2: 40 },
        });

        doc.save("APHomesBeneficiaryPaymentsReport.pdf");
    }
    return (
        <>
            <NavigationServicesHeader />
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                <ModuleHeader title="AP Homes Progess Report" />
                    <OFMSUI.Container className="outer-page-content-container " style={{ width: "90%" }} fluid >
                        <OFMSUI.Row>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                                <FormGroup as={Col}>
                                    <label> <b> District</b> </label>
                                    <span className="mandatory" style={{ color: "red" }}> * </span>
                                    <Field
                                        component="select"
                                        name="district"
                                        onChange={(e) => { formik.handleChange(e); }}
                                        className={formik.touched.district && formik.errors.district ? "form-control is-invalid" : "form-control"}
                                    >
                                        <option value="0">All</option>
                                        {distList}
                                    </Field>
                                </FormGroup>
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                                <FormGroup as={Col}>
                                    <label> <b> Phase</b> </label>
                                    <span className="mandatory" style={{ color: "red" }}> * </span>
                                    <Field
                                        component="select"
                                        name="phase"
                                        className={formik.touched.phase && formik.errors.phase ? "form-control is-invalid" : "form-control"}
                                    >
                                        <option value="0">All</option>
                                        {phaseList}
                                    </Field>
                                </FormGroup>
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                                <FormGroup as={Col}>
                                    <label> <b>Scheme</b> </label>
                                    <span className="mandatory" style={{ color: "red" }}> * </span>
                                    <Field
                                        component="select"
                                        name="scheme"
                                        className={formik.touched.scheme && formik.errors.scheme ? "form-control is-invalid" : "form-control"}
                                        onChange={(e) => { formik.handleChange(e) }}
                                    >
                                        <option value="0">All</option>
                                        {schemesList}
                                    </Field>
                                </FormGroup>
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" >
                                <FormGroup as={Col}>
                                    <label> <b> Date</b> </label>
                                    <span className="mandatory" style={{ color: "red" }}> * </span>
                                    <Field
                                        name="date"
                                        type="date"
                                        max={todayDate}
                                        onChange={(e) => formik.handleChange(e)}
                                        className={formik.touched.date && formik.errors.date ? "form-control is-invalid" : "form-control"}
                                    ></Field>
                                    {formik.touched.date && formik.errors.date ? (<div className="invalid-feedback">{formik.errors.date}</div>) : null}
                                </FormGroup>
                            </OFMSUI.Col>
                        <GetDetails/>
                        </OFMSUI.Row>
                        {table && (<>
                            <OFMSUI.Row>
                            </OFMSUI.Row>
                            <OFMSUI.Row>
                                <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                                    <div className="input-group">
                                        <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                                        <input type="text" id="#filterInput" placeholder="Search " style={{ width: "15%" }} className="form-control input-lg" value={searchText} onChange={handleSearch} ></input>
                                    </div>
                                </OFMSUI.Col>
                                <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                                    <button type="button" className="btn btn-danger btn-sm" onClick={ApHomesPDF} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                    <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} >
                                        <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-APHomesPDf" filename="APHomeProgressReport" sheet="tablexls" buttonText="Excel" >
                                            <FaFileExcel style={{ color: "#fff" }} />
                                        </ReactHTMLTableToExcel>
                                    </button>
                                </OFMSUI.Col>
                            </OFMSUI.Row>
                            <div style={{ overflow: "auto", margin: "0px", height: "620px" }} >
                                <OFMSUI.Table striped bordered hover id="my-APHomesPDf" indexid="index" style={{ marginTop: "15px" }} >
                                    <thead className="fw-bold" style={{ position: "sticky", top: "0px", textAlign: "initial" }} >
                    <tr> <th colSpan={69} style={{ textAlign: "center" }}> <h6> AP Homes Progess Report of {saveOptionDist} District, Phase: {saveOptionPhase}, Scheme : {saveOptionScehme}, Date : {saveDate}</h6> </th> </tr>


                                        <tr className="table_countshead">
                                            <th rowSpan={2} style={{ width: "50px" }}>S No.</th> <th rowSpan={2}>District</th> <th rowSpan={2}>Phase</th> <th rowSpan={2}>Scheme</th> <th rowSpan={2}>No of Beneficiaries</th> <th rowSpan={2}>NS</th>
                                            <th colSpan={7} style={{ textAlign: "center" }}>BBL</th> <th colSpan={7} style={{ textAlign: "center" }}>BL</th> <th colSpan={7} style={{ textAlign: "center" }}>LL</th> <th colSpan={7} style={{ textAlign: "center" }}>RL</th> <th colSpan={7} style={{ textAlign: "center" }}>RC</th> <th colSpan={7} style={{ textAlign: "center" }}>Completion</th>
                                            <th colSpan={6} style={{ textAlign: "center" }}>Additional Payments</th>
                                            <th colSpan={6} style={{ textAlign: "center" }}>Total</th>
                                        </tr>
                                        <tr className="table_countshead" style={{ textAlign: "right" }}>
                                            <th>No of Beneficiaries</th> <th>Payment</th> <th>No of bags</th> <th>Cement value</th> <th>Material value</th> <th>AF&BC Admin Charges</th> <th>Total</th> <th>No of Beneficiaries</th>
                                            <th>Payment</th> <th>No of bags</th> <th>Cement value</th> <th>Material value</th> <th>AF&BC Admin Charges</th> <th>Total</th> <th>No of Beneficiaries</th>
                                            <th>Payment</th> <th>No of bags</th> <th>Cement value</th> <th>Material value</th> <th>AF&BC Admin Charges</th> <th>Total</th> <th>No of Beneficiaries</th>
                                            <th>Payment</th> <th>No of bags</th> <th>Cement value</th> <th>Material value</th> <th>AF&BC Admin Charges</th> <th>Total</th> <th>No of Beneficiaries</th>
                                            <th>Payment</th> <th>No of bags</th> <th>Cement value</th> <th>Material value</th> <th>AF&BC Admin Charges</th> <th>Total</th> <th>No of Beneficiaries</th>
                                            <th>Payment</th> <th>No of bags</th> <th>Cement value</th> <th>Material value</th> <th>AF&BC Admin Charges</th>
                                            <th>Total</th> <th>Payment</th> <th>No of bags</th> <th>Cement value</th> <th>Material value</th> <th>AF&BC Admin Charges</th>
                                            <th>Total</th> <th>Payment</th> <th>No of bags</th> <th>Cement value</th> <th>Material value</th> <th>AF&BC Admin Charges</th> <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData?.length === 0 ? (<tr> <td style={{ textAlign: "center", color: "red" }} colSpan={69} > No Details Found. </td> </tr>) : (filteredData?.map((detail, i) => (
                                            <tr key={i} style={{ textAlign: "right" }}>
                                                <td>{i + 1}</td>
                                                <td style={{ textAlign: "left" }}>{detail.dist_name}</td>
                                                <td style={{ textAlign: "left" }}>{detail.phase_name}</td>
                                                <td style={{ textAlign: "left" }}>{detail.scheme_name}</td>
                                                <td>{detail.total}</td>
                                                <td>{detail.ns}</td>
                                                <td>{detail.bbl}</td>
                                                <td>{detail.bbl_payment}</td>
                                                <td>{detail.bbl_no_of_bags}</td>
                                                <td>{detail.bbl_cement}</td>
                                                <td>{detail.bbl_meterial}</td>
                                                <td>{detail.bbl_admin_charges}</td>
                                                <td>
                                                    {(
                                                        (detail.bbl_payment || 0) +
                                                        (detail.bbl_cement || 0) +
                                                        (detail.bbl_meterial || 0) +
                                                        (detail.bbl_admin_charges || 0)
                                                    )}
                                                </td>
                                                <td>{detail.bl}</td>
                                                <td>{detail.bl_payment}</td>
                                                <td>{detail.bl_no_of_bags}</td>
                                                <td>{detail.bl_cement}</td>
                                                <td>{detail.bl_material}</td>
                                                <td>{detail.bl_admin_charges}</td>
                                                <td>
                                                    {(
                                                        (detail.bl_payment || 0) +
                                                        (detail.bl_cement || 0) +
                                                        (detail.bl_material || 0) +
                                                        (detail.bl_admin_charges || 0)
                                                    )}
                                                </td>
                                                <td>{detail.ll}</td>
                                                <td>{detail.ll_payment}</td>
                                                <td>{detail.ll_no_of_bags}</td>
                                                <td>{detail.ll_cement}</td>
                                                <td>{detail.ll_material}</td>
                                                <td>{detail.ll_admin_charges}</td>
                                                <td>
                                                    {(
                                                        (detail.ll_payment || 0) +
                                                        (detail.ll_cement || 0) +
                                                        (detail.ll_material || 0) +
                                                        (detail.ll_admin_charges || 0)
                                                    )}
                                                </td>
                                                <td>{detail.rl}</td>
                                                <td>{detail.rl_payment}</td>
                                                <td>{detail.rl_no_of_bags}</td>
                                                <td>{detail.rl_cement}</td>
                                                <td>{detail.rl_material}</td>
                                                <td>{detail.rl_admin_charges}</td>
                                                <td>
                                                    {(
                                                        (detail.rl_payment || 0) +
                                                        (detail.rl_cement || 0) +
                                                        (detail.rl_material || 0) +
                                                        (detail.rl_admin_charges || 0)
                                                    )}
                                                </td>
                                                <td>{detail.rc}</td>
                                                <td>{detail.rc_payment}</td>
                                                <td>{detail.rc_no_of_bags}</td>
                                                <td>{detail.rc_cement}</td>
                                                <td>{detail.rc_material}</td>
                                                <td>{detail.rc_admin_charges}</td>
                                                <td>
                                                    {(
                                                        (detail.rc_payment || 0) +
                                                        (detail.rc_cement || 0) +
                                                        (detail.rc_material || 0) +
                                                        (detail.rc_admin_charges || 0)
                                                    )}
                                                </td>
                                                <td>{detail.comp}</td>
                                                <td>{detail.comp_payment}</td>
                                                <td>{detail.comp_no_of_bags}</td>
                                                <td>{detail.comp_cement}</td>
                                                <td>{detail.comp_material}</td>
                                                <td>{detail.comp_admin_chargest}</td>
                                                <td>
                                                    {(
                                                        (detail.comp_payment || 0) +
                                                        (detail.comp_cement || 0) +
                                                        (detail.comp_material || 0) +
                                                        (detail.comp_admin_chargest || 0)
                                                    )}
                                                </td>
                                                <td>{detail.other_payment}</td>
                                                <td>{detail.other_no_of_bags}</td>
                                                <td>{detail.other_cement}</td>
                                                <td>{detail.other_material}</td>
                                                <td>{detail.other_admin_charges}</td>
                                                <td>
                                                    {(
                                                        (detail.other_payment || 0) +
                                                        (detail.other_cement || 0) +
                                                        (detail.other_material || 0) +
                                                        (detail.other_admin_charges || 0)
                                                    )}
                                                </td>
                                                <td>{detail.tot_payment}</td>
                                                <td>{detail.tot_no_of_bags}</td>
                                                <td>{detail.tot_cement}</td>
                                                <td>{detail.tot_material}</td>
                                                <td>{detail.tot_admin_charges}</td>
                                                
                                                <td>
                                                    {(
                                                        (detail.tot_payment || 0) +
                                                        (detail.tot_cement || 0) +
                                                        (detail.tot_material || 0) +
                                                        (detail.tot_admin_charges || 0)
                                                    )}
                                                </td>

                                            </tr>
                                        )))}
                                    </tbody>
                                    <tfoot>
                                        <tr style={{ textAlign: "right" }}>
                                            <td colSpan={4} style={{ textAlign: "end" }}> Total  </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.total), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.ns), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bbl), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bbl_payment), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bbl_no_of_bags), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bbl_cement), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bbl_meterial), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bbl_admin_charges), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bbl_payment || 0) + parseInt(v.bbl_cement || 0) + parseInt(v.bbl_meterial || 0) + parseInt(v.bbl_admin_charges || 0), 0)} </td>





                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bl), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bl_payment), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bl_no_of_bags), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bl_cement), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bl_material), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bl_admin_charges), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.bl_payment || 0) + parseInt(v.bl_cement || 0) + parseInt(v.bl_material || 0) + parseInt(v.bl_admin_charges || 0), 0)} </td>


                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.ll), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.ll_payment), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.ll_no_of_bags), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.ll_cement), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.ll_material), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.ll_admin_charges), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.ll_payment || 0) + parseInt(v.ll_cement || 0) + parseInt(v.ll_material || 0) + parseInt(v.ll_admin_charges || 0), 0)} </td>


                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rl), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rl_payment), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rl_no_of_bags), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rl_cement), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rl_material), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rl_admin_charges), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rl_payment || 0) + parseInt(v.rl_cement || 0) + parseInt(v.rl_material || 0) + parseInt(v.rl_admin_charges || 0), 0)} </td>


                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rc), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rc_payment), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rc_no_of_bags), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rc_cement), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rc_material), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rc_admin_charges), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.rc_payment || 0) + parseInt(v.rc_cement || 0) + parseInt(v.rc_material || 0) + parseInt(v.rc_admin_charges || 0), 0)} </td>


                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.comp), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.comp_payment), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.comp_no_of_bags), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.comp_cement), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.comp_material), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.comp_admin_chargest), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.comp_payment || 0) + parseInt(v.comp_cement || 0) + parseInt(v.comp_material || 0) + parseInt(v.comp_admin_chargest || 0), 0)} </td>


                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.other_payment), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.other_no_of_bags), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.other_cement), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.other_material), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.other_admin_charges), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.other_payment || 0) + parseInt(v.other_cement || 0) + parseInt(v.other_material || 0) + parseInt(v.other_admin_charges || 0), 0)} </td>




                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.tot_payment), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.tot_no_of_bags), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.tot_cement), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.tot_material), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.tot_admin_charges), 0)} </td>
                                            <td style={{ textAlign: "right" }}> {filteredData?.reduce((a, v) => a + parseInt(v.tot_payment || 0) + parseInt(v.tot_cement || 0) + parseInt(v.tot_material || 0) + parseInt(v.tot_admin_charges || 0), 0)} </td>












                                        </tr>
                                    </tfoot>
                                </OFMSUI.Table>
                            </div>
                        </>)}
                    </OFMSUI.Container>
                </Form>

            </FormikProvider>

        </>
    )
}

export default ApHomesProgressReport
